var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tippy",rawName:"v-tippy",value:(_vm.options),expression:"options"}],staticClass:"w-4 h-4",attrs:{"content":_vm.content}},[_vm._t("default",function(){return [_c('InlineSvg',{class:_vm.iconColor,attrs:{"alt":_vm.content,"src":_vm.imageSrc}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }